import { Tab } from '../const';

/**
 * @function handleRow
 * @param { array } items
 * @param { string } id
 * @param { string } name
 * @param { string } value
 * @returns { array }
 */
function handleRow(items, id, name, value) {
	const results = items.map((item) => {
		if (item[Tab.Id] === id) {
			return { ...item, [name]: value };
		}
		return item;
	});

	return results;
}

export default handleRow;
